export default __webpack_public_path__ + "static/media/latest-news-img2.c8e5ed43.jpg";